import TagManager from 'react-gtm-module';

import { TakeoverTileSize } from '@adapters/prismic/types/plp';

import {
  DeferredNavigationProps,
  deferredNavigationFields,
} from './clickTracking';

/**
 * GA4 reports tile width in the merchandising team's language ("2 across"),
 * not the CMS's (`size: '2'`).
 */
export const PTT_TYPE_BY_SIZE: Record<TakeoverTileSize, string> = {
  [TakeoverTileSize.one]: '1 across',
  [TakeoverTileSize.two]: '2 across',
};

export interface TrackProductTakeoverTileClickProps
  extends DeferredNavigationProps {
  data: {
    /** Path the click happened on, e.g. `/en/products/camping-and-hiking` */
    interactionLocation: string;
    /** Resolved, locale-prefixed href of the tile */
    linkUrl: string;
    /** CTA label authored in Prismic, e.g. "Shop now" */
    linkText: string;
    coOpBrand: string | null;
    /** `1 across` | `2 across` — see `PTT_TYPE_BY_SIZE` */
    type: string;
  };
}

/**
 * ED-411 — the Product Takeover Tile's `user_interaction` click event. Fires
 * alongside the tile's existing `select_promotion` ecommerce event; the two
 * feed different GA4 reports.
 */
export const trackProductTakeoverTileClick = ({
  data,
  ...deferral
}: TrackProductTakeoverTileClickProps) => {
  const { interactionLocation, linkUrl, linkText, coOpBrand, type } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_ptt',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        link_text: linkText,
        coop_brand: coOpBrand,
        type,
      },
      ...deferredNavigationFields(deferral),
    },
  });
};
